/* eslint-disable no-plusplus */

import $ from 'jquery';
import * as API from '../API/API';
import { getCookie } from '../utilities/legacy-utilities';

const makeDefaultMetricsData = () => {
  return {
    loadTime: Date.now(),
    itemsClicked: [],
    scrollDistance: 0,
    windowSize: { width: 0, height: 0 },
    keysPressed: 0,
  };
};

const OpenLearningMetrics = Object.assign({}, makeDefaultMetricsData());
let inactiveTime = 0;
let blurTime = null;

export const resetMetrics = () => {
  Object.assign(OpenLearningMetrics, makeDefaultMetricsData());
  inactiveTime = 0;
  blurTime = null;
};

export const saveMetric = (currentCoursePath, currentPagePath) => {
  if (!currentCoursePath) {
    return;
  }
  const csrfToken = getCookie('csrftoken');

  let pathName = currentPagePath;

  const suffix = window.location.search;
  if (suffix.length !== 0) {
    pathName += suffix;
  }

  const unloadTime = new Date().getTime();
  const activeTime = unloadTime - OpenLearningMetrics.loadTime - inactiveTime;
  const data = {
    path: pathName,
    data: JSON.stringify({
      hostname: window.location.host,
      loadTime: OpenLearningMetrics.loadTime,
      unloadTime,
      activeTime,
      inactiveTime,
      itemsClicked: OpenLearningMetrics.itemsClicked,
      scrollDistance:
        OpenLearningMetrics.scrollDistance +
        OpenLearningMetrics.windowSize.height,
      windowSize: OpenLearningMetrics.windowSize,
      keysPressed: OpenLearningMetrics.keysPressed,
    }),
  };

  let beaconUsed = false;
  if (navigator.sendBeacon) {
    // Sending the csrftoken is OK here because this is never a cross-domain request
    data.csrfmiddlewaretoken = csrfToken;
    const beaconData = new Blob([$.param(data)], {
      type: 'application/x-www-form-urlencoded',
    });
    beaconUsed = navigator.sendBeacon(
      '/api/save-metric/pageLeave/',
      beaconData
    );
    data.csrfmiddlewaretoken = undefined;
  }

  if (!beaconUsed) {
    API.post('save-metric/pageLeave/', data, { async: false });
  }

  resetMetrics();
};

$(document)
  .scroll(() => {
    OpenLearningMetrics.scrollDistance = Math.max(
      OpenLearningMetrics.scrollDistance,
      $(document).scrollTop()
    );
  })
  .keypress(() => {
    OpenLearningMetrics.keysPressed++;
  });

$(window).load(() => {
  OpenLearningMetrics.windowSize.width = $(window).width();
  OpenLearningMetrics.windowSize.height = $(window).height();
});

$(window).resize(() => {
  OpenLearningMetrics.windowSize.width = $(window).width();
  OpenLearningMetrics.windowSize.height = $(window).height();
});

$(window)
  .on('click', (evt) => {
    const $target = $(evt.target);
    const classes = $target[0].className || '';
    let classList = [];

    if (classes !== '' && classes.split) {
      classList = classes.split(/\s+/);
    }

    OpenLearningMetrics.itemsClicked.push({
      id: $target.attr('id'),
      name: $target.prop('nodeName'),
      classes: classList,
      x: evt.pageX,
      y: evt.pageY,
      time: new Date().getTime() - OpenLearningMetrics.loadTime,
    });
  })
  .on('focus', () => {
    const focusTime = Date.now();
    if (blurTime !== null) {
      inactiveTime += focusTime - blurTime;
    }

    blurTime = null;
  })
  .on('blur', () => {
    blurTime = new Date().getTime();
  });
